import { Avatar } from './Avatar'
export default Avatar

export { skeletonAvatarPadrao, skeletonAvatarCircle } from './avatar-skeleton'

export { Avatar, AvatarProps } from './Avatar'
